import { render } from "./NubesPrecipitacionesPorRadar.vue?vue&type=template&id=49860de0&scoped=true"
import script from "./NubesPrecipitacionesPorRadar.vue?vue&type=script&lang=js"
export * from "./NubesPrecipitacionesPorRadar.vue?vue&type=script&lang=js"

import "./NubesPrecipitacionesPorRadar.vue?vue&type=style&index=0&id=49860de0&lang=scss&scoped=true"

import exportComponent from "/proyectos/programas-de-investigacion/cah-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49860de0"]])

export default __exports__